import State from '../interfaces/states/State';

import { createSelector } from 'reselect';

export const currentCategory$ = (state: State): string => state.userExplorer.current.currentCategory;

export const currentLabel$ = (state: State): string => state.userExplorer.current.currentLabel;

export const currentEvent$ = createSelector(
  currentCategory$,
  currentLabel$,
  (state: State) => state.userExplorer.userExplorerData.data.descr,
  (currentCategory, currentLabel, descriptions): any[] => {
    return descriptions
      // tslint:disable-next-line:triple-equals
      ? descriptions.filter(item => item.eventCategory == currentCategory && item.eventLabel == currentLabel)
      : null;
  }
);
